module.exports = __webpack_public_path__ + "static/media/galerija_2019 (15).72d022f9.jpg";